export default __webpack_public_path__ + "static/media/customer_type.fd748d99.svg";